module.exports = __webpack_public_path__ + "static/media/finalGift.8486abde.jpg";